export default {
  choose_language_label: '',
  empty_bag_info: '',
  empty_bag_button_label: '',
  minicart_label: '',
  expire_error_message: '',
  ingrid_not_available_error: '',
  error_header: 'Oops',
  default_error_message: '',
  product_not_found: '',
  voucher_not_found: 'Désolé, mais votre code n\'existe pas.',
  unavailable_items: 'Certains articles n\'étaient plus disponibles et ont été retirés du panier.',
  unavailable_items_info: '',
  address_shipping_note: '',
  country_mismatch: 'Pour le paiement, veuillez, s\'il vous plaît, utiliser le même pays que dans Paypal.',
  paypal_note: '',
  payment_method_failed: 'Ne vous inquiétez pas, vous n\'avez pas été débité.',
  selection_not_found: 'Quelque chose n\'a pas fonctionné.',
  required_valid_error: '',
  passwords_match_valid_error: '',
  email_valid_error: '',
  personnummer_valid_error: '',
  phone_valid_error: '',
  min_length_error: '',
  max_length_error: '',
  alphanumeric_valid_error: '',
  shipping_step_title: '',
  payment_step_title: '',
  payment_step_message: '',
  payment_group_title: '',
  payment_handling_cost_label: '',
  address_step_title: '',
  shipwallet_step_title: '',
  step_edit: '',
  shipping_step_button_title: '',
  address_step_button_title: '',
  shipwallet_step_button_title: '',
  shop_working_hours_info: '',
  shipwallet_step_readonly_label: '',
  information_header_label: '',
  information_button_label: '',
  shop_more_button_label: '',
  cart_label: '',
  checkout_button_label: '',
  close_cart_button_label: '',
  cart_separator_text: '',
  cart_wallet_klarna_checkout_label: '',
  voucher_input_label: '',
  voucher_input_placeholder: '',
  voucher_group_label: '',
  voucher_switch_button_label: '',
  voucher_apply_button_label: '',
  voucher_remove_button_label: '',
  pin_fetch_button_label: '',
  pin_input_label: '',
  pin_input_placeholder: '',
  pin_not_found_error_message: '',
  total_price_message: '',
  order_summary_label: 'Récapitulatif de votre commande',
  open_order_label: '',
  close_order_label: '',
  gift_wrap_switch_button_label: '',
  country_label: '',
  country_dropdown_placeholder: '',
  state_label: '',
  state_dropdown_placeholder: '',
  first_name_label: '',
  first_name_placeholder: '',
  last_name_label: '',
  company_placeholder: '',
  company_label: '',
  last_name_placeholder: '',
  email_label: '',
  email_placeholder: '',
  phone_number_label: '',
  phone_number_placeholder: '',
  address_1_label: '',
  address_1_placeholder: '',
  address_2_label: '',
  address_2_placeholder: '',
  houseNumber_placeholder: '',
  houseNumber_label: '',
  zip_code_label: '',
  zip_code_placeholder: '',
  city_label: '',
  city_placeholder: '',
  personal_number_label: '',
  personal_number_placeholder: '',
  ship_to_different_label: '',
  remember_me_label: '',
  consent_group_title: '',
  terms_and_conditions_label: '',
  terms_and_conditions_link_label: '',
  newsletter_checkbox_label: '',
  newsletter_checkbox_link_label: '',
  subtotal_label: '',
  shipping_label: '',
  shipping_sumary_label: '',
  payment_handling_label: '',
  newsletter_label: '',
  total_label: '',
  order_details_label: '',
  order_number_label: '',
  order_date_label: '',
  order_status_label: '',
  payment_method_receipt_title: '',
  delivery_method_receipt_title: '',
  shipping_address_receipt_title: '',
  bought_items_label: '',
  order_summary_receipt_title: '',
  print_receipt_label: '',
  thank_message: '',
  additional_notes_label: '',
  additional_notes_placeholder: '',
  place_order_button_label: '',
  place_order_button_paypal_label: '',
  contact_group_title: '',
  customer_information_group_title: '',
  shipping_country_group_title: '',
  shipping_address_group_title: '',
  billing_address_group_title: '',
  order_message_group_title: '',
  billing_address_checkbox_label: '',
  billing_address_receipt_title: '',
  continue_shopping_receipt_link_label: '',
  membership_no_orders_message: '',
  membership_register_error_email: '',
  membership_customer_not_fount: '',
  membership_register_error_other: '',
  membership_login_error_password: '',
  membership_password_reset_link_expire_error: '',
  membership_tabs_personal: '',
  membership_tabs_password: '',
  membership_tabs_orders: '',
  membership_personal_data_title: '',
  membership_personal_data_subtitle: '',
  membership_change_password_title: '',
  membership_change_password_subtitle: '',
  membership_forgot_password_title: '',
  membership_forgot_password_subtitle: '',
  membership_recovery_password_title: '',
  membership_recovery_password_subtitle: '',
  membership_login_title: '',
  membership_login_subtitle: '',
  membership_orders_history_title: '',
  membership_orders_history_subtitle: '',
  membership_firstname_placeholder: '',
  membership_firstname_label: '',
  membership_lastname_placeholder: '',
  membership_lastname_label: '',
  membership_address1_placeholder: '',
  membership_address1_label: '',
  membership_address2_placeholder: '',
  membership_address2_label: '',
  membership_country_placeholder: '',
  membership_country_label: '',
  membership_city_placeholder: '',
  membership_city_label: '',
  membership_state_placeholder: '',
  membership_state_label: '',
  membership_zipcode_placeholder: '',
  membership_zipcode_label: '',
  membership_email_placeholder: '',
  membership_email_label: '',
  membership_phone_placeholder: '',
  membership_phone_label: '',
  membership_password_placeholder: '',
  membership_password_label: '',
  membership_show_password_tooltip: '',
  membership_password_confirm_placeholder: '',
  membership_password_confirm_label: '',
  membership_new_password_placeholder: '',
  membership_new_password_label: '',
  membership_new_password_save: '',
  membership_password_recovery: '',
  membership_identity_number_placeholder: '',
  membership_identity_number_label: '',
  membership_physical_store_placeholder: '',
  membership_physical_store_label: '',
  membership_register_continue_button_label: '',
  membership_save: '',
  membership_update: '',
  membership_login_button_label: '',
  membership_back_to_login: '',
  membership_logout: '',
  membership_forgotten_password: '',
  membership_not_your_account: '',
  membership_continue_as_guest: '',
  membership_continue: '',
  membership_start: '',
  membership_greeting: '',
  membership_close_overlay: '',
  membership_show_more: '',
  membership_order_status: '',
  membership_order_delivery: '',
  membership_order_summary_title: '',
  membership_account_subtitle: '',
  notifications_recovery_success: '',
  notifications_change_success: '',
  notifications_update_success: '',
  membership_gender_female: '',
  membership_gender_male: '',
  membership_personal_information_group_title: '',
  membership_gender_label: '',
  membership_gender_placeholder: '',
  membership_dob_label: '',
  membership_dob_placeholder: '',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/i18n/fr.ts